<script lang="ts" setup>
import { Button, Icon } from '@brighterly/lib-lumee-ui'

import type { LessonRoomGuideCategory } from '../../model/types/lesson-room/enums'

import { LESSON_ROOM_GUIDES, LESSON_ROOM_GUIDE_ORDER } from '../../config/lesson-room-guides'

defineOptions({
  name: 'LessonRoomGuideCategories',
})

const emit = defineEmits<{
  'click:category': [LessonRoomGuideCategory]
}>()
</script>

<template>
  <div class="lesson-room-guide-categories">
    <p class="lesson-room-guide-categories__heading btly-text-title-l">
      Which device do you need help with?
    </p>

    <ul class="lesson-room-guide-categories__list">
      <li
        v-for="category in LESSON_ROOM_GUIDE_ORDER"
        :key="category"
      >
        <Button
          view="secondary"
          size="md"
          fill
          :text="LESSON_ROOM_GUIDES[category].label"
          @click="emit('click:category', category)"
        >
          <template #leading>
            <Icon
              v-bind="LESSON_ROOM_GUIDES[category].icon"
              size="sm"
              color="inherit"
            />
          </template>
        </Button>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss" src="./LessonRoomGuideCategories.scss" />